import React, { useState, useEffect } from "react";
import "./InvoiceDetail.css";
import { MdOutlineMail } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit, FiDownload } from "react-icons/fi";
import { IoChevronBack, IoPersonSharp } from "react-icons/io5";
import { FaRegNewspaper } from "react-icons/fa6";
import { GrNotification } from "react-icons/gr";
import Header from "../../components/common/Header";
import config from "../../config";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import SuccessPopup from "../../components/common/SuccessPopup";
import ErrorPopup from "../../components/common/ErrorPopup";
import ConfirmPopup from "../../components/common/ConfirmPopup";

const InvoiceDetail = ({ invoice, isSubVendor, onBack, userDetails, selectedClientId }) => {
  const subVendorKey = invoice.subVendorKey || selectedClientId;
  const [isEditing, setIsEditing] = useState(false);
  const clientKey = selectedClientId || invoice.clientKey;
  const [employees, setEmployees] = useState([]);
  const [selectedJobRoles, setSelectedJobRoles] = useState([]);
  const [jobRoleOptions, setJobRoleOptions] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [confirmMessage, setConfirmMessage] = useState("");

  const [formData, setFormData] = useState({
    client: invoice.clientName || invoice.vendorName || "",
    clientKey: isSubVendor
      ? invoice.subVendorKey
      : selectedClientId || "",
    primaryContacts: "",
    emailId: "",
    workSite: invoice.workSite || "",
    primaryContactsEmailId: "",
    payrollMonth: invoice.settlementMonth || "",
    invoiceKey: invoice.invoiceKey || "",
    invoiceDate: invoice.invoiceDate || "",
    subTotal: "",
    dueDate: "",
    taxAmount: "",
    invoiceAmount: invoice.amount || "",
    paymentStatus: invoice.status || "Un Paid",
    uploadedFile: "inv005.pdf",
    noOfEmployees: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const toggleJobRole = (role) => {
    if (selectedJobRoles.includes(role)) {
      setSelectedJobRoles(selectedJobRoles.filter((r) => r !== role));
    } else {
      setSelectedJobRoles([...selectedJobRoles, role]);
    }
  };

  const removeJobRole = (role) => {
    setSelectedJobRoles(selectedJobRoles.filter((r) => r !== role));
  };

  const handleMail = () => {
    setSuccessMessage("Mail functionality to be implemented");
  };

  const handleDelete = () => {
    setConfirmMessage("Are you sure you want to delete this invoice?");
  };

  const executeDelete = async () => {
    setConfirmMessage("");
    try {

      let url = "";

      if (isSubVendor) {

        const subVendorKey = invoice.subVendorKey || selectedClientId;

        url = `${config.API_BASE_URL}/api/v1/sub-vendor-invoice/delete?orgKey=${invoice.orgKey}&subVendorKey=${subVendorKey}&invoiceKey=${invoice.invoiceKey}`;

      } else {

        const clientKey = selectedClientId || invoice.clientKey;

        url = `${config.API_BASE_URL}${config.CLIENT_INVOICE_DELETE_ENDPOINT}?orgKey=${invoice.orgKey}&clientKey=${clientKey}&invoiceKey=${invoice.invoiceKey}`;
      }

      console.log("DELETE API:", url); // 🔥 check in console

      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${userDetails.token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      console.log("Delete Response:", data);

      if (response.ok) {
        setSuccessMessage("Invoice deleted successfully");
      } else {
        setErrorMessage(data.message || "Delete failed");
      }

    } catch (error) {
      console.error("Delete error:", error);
      setErrorMessage("Something went wrong while deleting invoice");
    }
  };


  const handleEdit = async () => {

    // If already editing → Save button pressed
    if (isEditing) {

      try {

        const payload = {
          orgKey: invoice.orgKey,
          clientKey: selectedClientId || invoice.clientKey,
          invoiceKey: formData.invoiceKey,
          invoiceDate: formData.invoiceDate,
          dueDate: formData.dueDate,
          subTotal: formData.subTotal,
          taxAmount: formData.taxAmount,
          invoiceAmount: formData.invoiceAmount,
          paymentStatus: formData.paymentStatus,
          settlementMonth: formData.payrollMonth,
          workSite: formData.workSite,
          emailId: formData.emailId,
          primaryContactName: formData.primaryContacts,
          primaryContactEmailId: formData.primaryContactsEmailId
        };

        const response = await fetch(
          `${config.API_BASE_URL}/api/v1/client-invoice/update`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${userDetails.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );

        const data = await response.json();

        if (response.ok) {
          setSuccessMessage("Invoice updated successfully");
          setIsEditing(false);
          fetchInvoiceDetails(); // refresh
        } else {
          setErrorMessage(data.message || "Update failed");
        }

      } catch (error) {
        console.error("Update error:", error);
        setErrorMessage("Something went wrong");
      }

    } else {

      // Enable edit mode
      setIsEditing(true);

    }

  };
  console.log("isSubVendor:", isSubVendor);
  console.log("invoice:", invoice);

  const fetchJobRoles = async () => {
    try {
      const response = await fetch(
        `${config.API_BASE_URL}${config.VIEW_CLIENT_CONFIG_ENDPOINT}${invoice.orgKey}?configType=JobRole`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${userDetails.token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        const roles = data?.map((item) => item.values) || [];
        setJobRoleOptions(roles);
      }
    } catch (error) {
      console.error("Error fetching Job Roles:", error);
    }
  };
  const fetchInvoiceDetails = async () => {
    try {
      let url = "";

      if (isSubVendor) {
        // Sub-vendor URL uses subVendorKey
        url = `${config.API_BASE_URL}${config.SUBVENDOR_INVOICE_DETAIL_ENDPOINT}?orgKey=${invoice.orgKey}&subVendorKey=${invoice.subVendorKey || selectedClientId}&invoiceKey=${invoice.invoiceKey}`;
      } else {
        url = `${config.API_BASE_URL}${config.CLIENT_INVOICE_DETAIL_ENDPOINT}?orgKey=${invoice.orgKey}&clientKey=${selectedClientId}&invoiceKey=${invoice.invoiceKey}`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${userDetails.token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (response.ok) {
        const inv = data.body;

        // ✅ Mapping API data to Form Data correctly
        setFormData({
          // Sub-vendor-ku 'subVendorName' nu varum, Client-ku 'clientName' nu varum
          client: isSubVendor ? (inv.subVendorName || inv.primaryContactName) : (inv.clientName || ""),
          clientKey: isSubVendor ? (inv.subVendorKey || "") : (inv.clientKey || ""),
          primaryContacts: inv.primaryContactName || "",
          emailId: inv.emailId || "",
          workSite: inv.workSite || "",
          primaryContactsEmailId: inv.primaryContactEmailId || "",
          // Check if API returns settlementMonth or payrollMonth
          payrollMonth: inv.settlementMonth || inv.payrollMonth || "",
          invoiceKey: inv.invoiceKey || "",
          invoiceDate: inv.invoiceDate?.split("T")[0] || "",
          subTotal: inv.subTotal || "",
          dueDate: inv.dueDate?.split("T")[0] || "",
          taxAmount: inv.taxAmount || "",
          invoiceAmount: inv.invoiceAmount || "",
          paymentStatus: inv.paymentStatus || "",
          uploadedFile: inv.invoiceFileName || "",
          // Indha key romba mukkiyam for Sub-Vendor UI
          noOfEmployees: inv.noOfEmployees || "",
        });

        setEmployees(inv.employeeDetails || []);
        setSelectedJobRoles(inv.jobRoles || []);

        return inv;
      }
      return null;
    } catch (error) {
      console.error("Error fetching invoice details:", error);
      return null;
    }
  };
  // 3. Update Totals Calculation (Handle nulls from API)
  const totals = employees.reduce(
    (acc, emp) => ({
      grossPay: acc.grossPay + (Number(emp.grossPay) || 0),
      deduction: acc.deduction + (Number(emp.deduction) || 0),
      overTime: acc.overTime + (Number(emp.overTime) || 0),
      netPay: acc.netPay + (Number(emp.netPay) || 0),
    }),
    { grossPay: 0, deduction: 0, overTime: 0, netPay: 0 }
  );
  const handleDownloadPdf = async () => {
    const inv = await fetchInvoiceDetails();
    if (!inv) return;

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 14;
    let y = 25;

    // Colors
    const darkGrey = [31, 41, 55]; // #1f2937
    const mutedGrey = [107, 114, 128]; // #6b7280
    const primaryBlue = [37, 99, 235]; // #2563eb
    const lightGreyBg = [249, 250, 251]; // #f9fafb

    const formatCurrency = (amount) => {
      // Format with en-IN and remove any non-breaking spaces that cause jsPDF rendering issues
      return Number(amount || 0).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).replace(/\u00A0|\u202F/g, " ");
    };

    // =========================
    // HEADER
    // =========================
    doc.setFontSize(28);
    doc.setTextColor(...darkGrey);
    doc.setFont("helvetica", "bold");
    doc.text("INVOICE", margin, y);

    doc.setFontSize(16);
    doc.setTextColor(...mutedGrey);
    doc.text(localStorage.getItem("companyName") || "Organisation Name", pageWidth - margin, y, { align: "right" });

    y += 14;

    // =========================
    // 3 COLUMN TOP SECTION
    // =========================
    doc.setFontSize(10);
    doc.setTextColor(...darkGrey);

    // LEFT COLUMN (Invoice Summary)
    doc.setFont("helvetica", "bold");
    doc.text(`Payable INR ${formatCurrency(inv.invoiceAmount)}`, margin, y);

    doc.setFont("helvetica", "normal");
    doc.setTextColor(...mutedGrey);
    const infoY = y + 7;
    doc.text(`Dues ${inv.dueDate?.split("T")[0] || "-"}`, margin, infoY);
    doc.text(`Issued ${inv.invoiceDate?.split("T")[0] || "-"}`, margin, infoY + 6);
    doc.text(`Ref. #${inv.invoiceKey}`, margin, infoY + 12);

    // MIDDLE COLUMN (Billed To)
    const usableWidth = pageWidth - (margin * 2);
    const colWidth = usableWidth / 3;
    const midX = margin + colWidth;
    doc.setFont("helvetica", "bold");
    doc.setTextColor(...darkGrey);
    doc.text("Billed to", midX, y);

    doc.setFont("helvetica", "normal");
    doc.setTextColor(...mutedGrey);
    doc.text(inv.clientName || "Client Name", midX, infoY);
    doc.text(inv.emailId || "Client email", midX, infoY + 6);
    doc.text(inv.workSite || "Client address", midX, infoY + 12);

    // RIGHT COLUMN (From)
    const fromX = margin + (colWidth * 2);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(...darkGrey);
    doc.text("From", fromX, y, { align: "left" });

    doc.setFont("helvetica", "normal");
    doc.setTextColor(...mutedGrey);
    doc.text(localStorage.getItem("companyName") || "Company Name", fromX, infoY, { align: "left" });
    doc.text("Business address", fromX, infoY + 6, { align: "left" });
    doc.text("City, State, PIN - 000 000", fromX, infoY + 12, { align: "left" });
    doc.text("TAX ID: 00XXXXX1234X0XX", fromX, infoY + 18, { align: "left" });

    y += 30;

    // =========================
    // SERVICES TABLE
    // =========================
    const employeeData = inv.employeeDetails || [];
    const roleSummary = {};

    employeeData.forEach(emp => {
      const role = emp.jobRole || "General Services";
      if (!roleSummary[role]) {
        roleSummary[role] = { qty: 0, total: 0 };
      }
      roleSummary[role].qty += 1;
      roleSummary[role].total += Number(emp.netPay || 0);
    });

    const tableBody = Object.keys(roleSummary).map(role => [
      role,
      roleSummary[role].qty,
      `Rs. ${formatCurrency(roleSummary[role].total)}`
    ]);

    let colDimensions = {};
    const cardStartY = y;
    const cellPadding = 3.2; // Optimized compact cell padding for a highly professional layout

    autoTable(doc, {
      startY: y,
      head: [[
        { content: "Services", styles: { halign: "left" } },
        { content: "Qty", styles: { halign: "center" } },
        { content: "Line total", styles: { halign: "right" } }
      ]],
      body: tableBody,
      theme: "plain",
      styles: {
        fontSize: 9,
        cellPadding: cellPadding,
        textColor: darkGrey,
        font: "helvetica",
      },
      headStyles: {
        fillColor: lightGreyBg,
        textColor: mutedGrey,
        fontStyle: "bold",
        fontSize: 9.5,
      },
      columnStyles: {
        0: { halign: "left" },
        1: { halign: "center", cellWidth: 30 },
        2: { halign: "right", cellWidth: 40 },
      },
      didDrawCell: (data) => {
        // Capture column dimensions for perfect bottom alignment
        if (data.row.section === 'head') {
          colDimensions[data.column.index] = {
            x: data.cell.x,
            width: data.cell.width
          };
        }

        // Draw bottom border for rows
        if (data.row.index >= 0) {
          doc.setDrawColor(229, 231, 235); // #e5e7eb
          doc.line(data.cell.x, data.cell.y + data.cell.height, data.cell.x + data.cell.width, data.cell.y + data.cell.height);
        }
      }
    });

    y = doc.lastAutoTable.finalY + 5;

    // =========================
    // TOTAL SECTION
    // =========================
    const subTotal = Number(inv.subTotal || Object.values(roleSummary).reduce((acc, item) => acc + item.total, 0));
    const taxAmount = Number(inv.taxAmount || 0);
    const totalDue = Number(inv.invoiceAmount || (subTotal + taxAmount));
    const taxRate = subTotal > 0 ? Math.round((taxAmount / subTotal) * 100) : 0;
    const taxLabel = taxRate > 0 ? `Tax (${taxRate}%)` : "Tax (18%)";

    const col0LeftX = colDimensions[0] ? colDimensions[0].x + cellPadding : margin + cellPadding;
    const col1CenterX = colDimensions[1] ? colDimensions[1].x + (colDimensions[1].width / 2) : (pageWidth / 2);
    const col2RightX = colDimensions[2] ? colDimensions[2].x + colDimensions[2].width - cellPadding : pageWidth - margin - cellPadding;

    // Draw Subtotal Row
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...darkGrey);
    doc.text("Subtotal", col0LeftX, y);
    doc.text(`Rs. ${formatCurrency(subTotal)}`, col2RightX, y, { align: "right" });

    y += 6;

    // Draw Tax Row
    doc.text(taxLabel, col0LeftX, y);
    doc.text(`Rs. ${formatCurrency(taxAmount)}`, col2RightX, y, { align: "right" });

    y += 6;

    // Draw separator line before total due box
    doc.setDrawColor(229, 231, 235);
    doc.line(margin, y - 3, pageWidth - margin, y - 3);

    // Draw the Total Due shaded box background
    doc.setFillColor(...lightGreyBg);
    doc.rect(margin, y - 1, pageWidth - (margin * 2), 12, "F");

    // Draw Total Due text (aligned: "Total due" under Qty column, value right aligned)
    doc.setFontSize(10);
    doc.setTextColor(...primaryBlue);
    doc.setFont("helvetica", "bold");
    doc.text("Total due", col1CenterX, y + 7, { align: "center" });
    doc.text(`INR Rs. ${formatCurrency(totalDue)}`, col2RightX, y + 7, { align: "right" });

    // Draw the card boundary border
    const cardEndY = y + 11;
    doc.setDrawColor(229, 231, 235);
    doc.setLineWidth(0.3);
    doc.roundedRect(margin, cardStartY, pageWidth - margin * 2, cardEndY - cardStartY, 4, 4, "D");

    y = cardEndY + 12;

    // =========================
    // FOOTER SECTION
    // =========================
    doc.setFontSize(9);


    // Vertical Accent Line for Payment Details
    doc.setDrawColor(...darkGrey);
    doc.setLineWidth(1);
    doc.line(margin, y - 2, margin, y + 12);

    const footerTextX = margin + 5;
    doc.setTextColor(...darkGrey);
    doc.setFont("helvetica", "bold");
    doc.text("Payment details", footerTextX, y);

    doc.setFont("helvetica", "normal");
    doc.setTextColor(...mutedGrey);
    const footerInfo = [
      "Please pay within 15 days of",
      "receiving this invoice."
    ];
    doc.text(footerInfo, footerTextX, y + 5);

    // Bank details columns
    const bankCol1X = pageWidth / 2 + 10;
    const bankCol2X = pageWidth - margin;

    doc.setTextColor(...darkGrey);
    doc.setFont("helvetica", "bold");
    doc.text("Account Holder", bankCol1X, y);
    doc.setFont("helvetica", "normal");
    doc.text(inv.accountHolderName || "Wtilth Technologies Pvt Ltd", bankCol2X, y, { align: "right" });

    doc.setFont("helvetica", "bold");
    doc.text("Bank name", bankCol1X, y + 5);
    doc.setFont("helvetica", "normal");
    doc.text(inv.bankName || "HDFC Bank", bankCol2X, y + 5, { align: "right" });

    doc.setFont("helvetica", "bold");
    doc.text("Account #", bankCol1X, y + 10);
    doc.setFont("helvetica", "normal");
    doc.text(inv.accountNumber || "50100475397270", bankCol2X, y + 10, { align: "right" });

    doc.setFont("helvetica", "bold");
    doc.text("IFSC code", bankCol1X, y + 15);
    doc.setFont("helvetica", "normal");
    doc.text(inv.ifsc || "HDFC0002615", bankCol2X, y + 15, { align: "right" });

    doc.setFont("helvetica", "bold");
    doc.text("Branch", bankCol1X, y + 20);
    doc.setFont("helvetica", "normal");
    doc.text(inv.branch || "KK Nagar", bankCol2X, y + 20, { align: "right" });

    y += 25;

    // Bottom text with accent
    doc.setDrawColor(...darkGrey);
    doc.line(margin, y - 2, margin, y + 4);

    doc.setFont("helvetica", "bold");
    doc.setTextColor(...darkGrey);
    doc.text("Thanks for the business.", footerTextX, y);

    doc.setFont("helvetica", "normal");
    doc.setTextColor(...mutedGrey);
    doc.text("hello@email.com", bankCol1X, y);
    doc.text("+91 00000 00000", bankCol2X, y, { align: "right" });

    doc.save(`Invoice_${inv.invoiceKey}.pdf`);
  };
  console.log("Invoice in Detail Component:", invoice);
  useEffect(() => {
    if (!invoice || !userDetails?.token) return;

    fetchInvoiceDetails();

    if (!isSubVendor && selectedClientId) {
      fetchJobRoles();
    }

  }, [invoice, selectedClientId, userDetails?.token, isSubVendor]);
  return (
    <div className="invoice-detail-container">
      {/* Header */}
      <Header
        showBack={false}
        title={formData.invoiceKey}
        subtitle={
          <p className="breadcrumb" style={{ margin: 0 }}>
            <span className="back-link" onClick={onBack} style={{ cursor: "pointer" }}>
              <IoChevronBack style={{ verticalAlign: "middle" }} /> All Invoice
            </span>
            <span className="separator"> &gt; </span>
            <span>{isSubVendor ? invoice.vendorName : invoice.clientName}</span>
          </p>
        }
      />

      {/* Main Content Card */}
      <div className="invoice-detail-card">
        {/* Client/Sub Vendor Information Section */}
        <div className="section-header">
          <div className="section-title-wrapper">
            <span className="section-icon"><IoPersonSharp />
            </span>
            <span className="section-title">{isSubVendor ? "Sub Vendor Information" : "Client Information"}</span>
          </div>
          <div className="action-buttons">
            <button className="btn-mail" onClick={handleMail}>
              <MdOutlineMail /> Mail
            </button>
            <button className="btn-delete" onClick={handleDelete}>
              <RiDeleteBin6Line /> Delete
            </button>
            <button className="btn-edit" onClick={handleEdit}>
              <FiEdit /> {isEditing ? "Save" : "Edit"}
            </button>
          </div>
        </div>

        <div className="form-grid">
          <div className="form-group">
            <label>{isSubVendor ? "Sub Vendor Name" : "Client"}</label>
            <input
              type="text"
              name="client"
              value={formData.client}
              onChange={handleInputChange}
              disabled={!isEditing}
            />
          </div>
          <div className="form-group">
            <label>{isSubVendor ? "Sub Vendor Key" : "Client Key"}</label>
            <input
              type="text"
              name="clientKey"
              value={formData.clientKey}
              onChange={handleInputChange}
              disabled={!isEditing}
            />
          </div>
          <div className="form-group">
            <label>Primary Contacts</label>
            <input
              type="text"
              name="primaryContacts"
              value={formData.primaryContacts}
              onChange={handleInputChange}
              disabled={!isEditing}
            />
          </div>
          <div className="form-group">
            <label>Email ID</label>
            <input
              type="email"
              name="emailId"
              value={formData.emailId}
              onChange={handleInputChange}
              disabled={!isEditing}
            />
          </div>
          <div className="form-group">
            <label>Work Site</label>
            <input
              type="text"
              name="workSite"
              value={formData.workSite}
              onChange={handleInputChange}
              disabled={!isEditing}
            />
          </div>
          <div className="form-group">
            <label>Primary Contacts Email ID</label>
            <input
              type="email"
              name="primaryContactsEmailId"
              value={formData.primaryContactsEmailId}
              onChange={handleInputChange}
              disabled={!isEditing}
            />
          </div>
          <div className="form-group">
            <label>Settlement Month</label>
            <input
              type="text"
              name="payrollMonth"
              value={formData.payrollMonth}
              onChange={handleInputChange}
              disabled={!isEditing}
            />
          </div>
          {isSubVendor && (
            <div className="form-group">
              <label>No of Employees</label>
              <input
                type="text"
                name="noOfEmployees"
                value={formData.noOfEmployees || ""}
                onChange={handleInputChange}
                disabled={!isEditing}
              />
            </div>
          )}
          <div className="form-group file-upload-group">
            <div className="file-upload-area">
              <div className="file-info">
                <span className="file-name">{formData.uploadedFile}</span>
                <button className="download-btn" onClick={handleDownloadPdf}>
                  <FiDownload />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Invoice Details Section */}
        <div className="section-header">
          <div className="section-title-wrapper">
            <span className="section-icon"><FaRegNewspaper /></span>
            <span className="section-title">Invoice Details</span>
          </div>
          <div></div>
        </div>

        <div className="form-grid">
          <div className="form-group">
            <label>Invoice Key</label>
            <input
              type="text"
              name="invoiceKey"
              value={formData.invoiceKey}
              onChange={handleInputChange}
              disabled={!isEditing}
            />
          </div>
          <div className="form-group">
            <label>Invoice Date</label>
            <input
              type="text"
              name="invoiceDate"
              value={formData.invoiceDate}
              onChange={handleInputChange}
              disabled={!isEditing}
            />
          </div>
          <div className="form-group">
            <label>Sub Total</label>
            <input
              type="text"
              name="subTotal"
              value={formData.subTotal}
              onChange={handleInputChange}
              disabled={!isEditing}
            />
          </div>
          <div className="form-group">
            <label>Due Date</label>
            <input
              type="text"
              name="dueDate"
              value={formData.dueDate}
              onChange={handleInputChange}
              disabled={!isEditing}
            />
          </div>
          {/* <div className="form-group">
            <label>Tax Amount</label>
            <input
              type="text"
              name="taxAmount"
              value={formData.taxAmount}
              onChange={handleInputChange}
              disabled={!isEditing}
            />
          </div> */}
          <div className="form-group">
            <label>Invoice Amount</label>
            <input
              type="text"
              name="invoiceAmount"
              value={formData.invoiceAmount}
              onChange={handleInputChange}
              disabled={!isEditing}
            />
          </div>
          <div className="form-group">
            <label>Payment Status</label>
            <select
              name="paymentStatus"
              value={formData.paymentStatus}
              onChange={handleInputChange}
              disabled={!isEditing}
            >
              <option value="Paid">Paid</option>
              <option value="Un Paid">Un Paid</option>
              <option value="Partially Paid">Partially Paid</option>
            </select>
          </div>
        </div>

        {/* Job Role Filter Section */}
        <div className="job-role-section">
          <div className="job-role-labels">
            <span className="job-role-label-left">Job Role</span>
            <span className="job-role-label-right">Filter</span>
          </div>

          <div className="job-role-inputs">

            {/* Selected Job Role Tags */}
            <div className="job-role-input-left">
              {selectedJobRoles.length === 0 ? (
                <span className="placeholder-text">Select job roles</span>
              ) : (
                <div className="job-role-tags-inline">
                  {selectedJobRoles.map((role) => (
                    <span key={role} className="job-role-tag">
                      {role}
                      <button
                        className="remove-tag"
                        onClick={() => removeJobRole(role)}
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>

            {/* 🔥 Dropdown place */}
            <select
              className="job-role-input-right"
              onChange={(e) => {
                if (e.target.value) {
                  toggleJobRole(e.target.value);
                  e.target.value = "";
                }
              }}
              value=""
            >
              <option value="">Job Role</option>

              {jobRoleOptions
                .filter((role) => !selectedJobRoles.includes(role))
                .map((role) => (
                  <option key={role} value={role}>
                    {role}
                  </option>
                ))}
            </select>

          </div>
        </div>

        {/* Employee Table */}
        {/* Employee Table */}
        {/* Employee Table */}
        {!isSubVendor && (
          <table className="employee-table">
            <thead>
              <tr>
                <th>Employee Name</th>
                <th>Job Role</th>
                <th>No of Days Worked</th>
                <th>Gross Pay</th>
                <th>Deduction</th>
                <th>Over Time</th>
                <th>Net Pay</th>
              </tr>
            </thead>
            <tbody>
              {employees.map((emp, index) => (
                <tr key={index}>
                  <td>{emp.employeeName}</td>
                  <td>{emp.jobRole}</td>
                  <td>{emp.noOfDaysWorked} Days</td>
                  <td>₹ {Number(emp.grossPay || 0).toLocaleString()}</td>
                  <td>{Number(emp.deduction || 0).toLocaleString()}</td>
                  <td>₹ {Number(emp.overTime || 0).toLocaleString()}</td>
                  <td>₹ {Number(emp.netPay || 0).toLocaleString()}</td>
                </tr>
              ))}
              <tr className="total-row">
                <td colSpan="3" className="total-label">Total :</td>
                <td>₹ {totals.grossPay.toLocaleString()}</td>
                <td>{totals.deduction.toLocaleString()}</td>
                <td>₹ {totals.overTime.toLocaleString()}</td>
                <td>₹ {totals.netPay.toLocaleString()}</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>

      {successMessage && (
        <SuccessPopup
          message={successMessage}
          onClose={() => {
            setSuccessMessage("");
            if (successMessage.includes("delete")) {
              onBack();
            }
          }}
        />
      )}
      {errorMessage && (
        <ErrorPopup
          message={errorMessage}
          onClose={() => setErrorMessage("")}
        />
      )}
      {confirmMessage && (
        <ConfirmPopup
          message={confirmMessage}
          onConfirm={executeDelete}
          onCancel={() => setConfirmMessage("")}
        />
      )}
    </div>
  );
};

export default InvoiceDetail;
